import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export const useUser = () => {
    const page = usePage();

    const currentUser = computed(() => page.props.currentUser);

    return {
        currentUser: currentUser.value,
        currentUserFirstname: currentUser.value.firstname,
        currentUserLastname: currentUser.value.lastname,
        currentUserFullName: currentUser.value.fullName,
        currentUserEmail: currentUser.value.email,
    };
};
